module.exports = __webpack_public_path__ + "static/img/IMG_20241208_154824.70aea8ae.jpg";